import { formatNumber2 } from './finance.js';

// Fusion DOCX (pur, sans Firebase) : port de la logique METAFLOW pour les devis / factures.
// ---------- Manipulation XML du tableau d'articles (port de METAFLOW) ----------
export const findItemsTableInXml = (xml) => {
  const txbxRegex = /<w:txbxContent[^>]*>([\s\S]*?)<\/w:txbxContent>/g;
  let m;
  while ((m = txbxRegex.exec(xml)) !== null) {
    if (m[1].includes('TOTAL') && m[1].includes('TVA')) {
      const tbl = m[1].match(/<w:tbl\b[\s\S]*?<\/w:tbl>/);
      if (tbl) { const start = xml.indexOf(tbl[0]); return { table: tbl[0], tableStart: start, tableEnd: start + tbl[0].length }; }
    }
  }
  const allTbl = /<w:tbl\b[\s\S]*?<\/w:tbl>/g;
  while ((m = allTbl.exec(xml)) !== null) {
    if (m[0].includes('TOTAL') && m[0].includes('TVA')) return { table: m[0], tableStart: m.index, tableEnd: m.index + m[0].length };
  }
  return null;
};
const getTableRows = (tableXml) => { const rows = []; const re = /<w:tr\b[\s\S]*?<\/w:tr>/g; let m; while ((m = re.exec(tableXml)) !== null) rows.push({ xml: m[0], index: m.index }); return rows; };
const getRowText = (rowXml) => { const t = []; const re = /<w:t[^>]*>([^<]*)<\/w:t>/g; let m; while ((m = re.exec(rowXml)) !== null) t.push(m[1]); return t.join(''); };
const getRowCells = (rowXml) => { const c = []; const re = /<w:tc\b[\s\S]*?<\/w:tc>/g; let m; while ((m = re.exec(rowXml)) !== null) c.push(m[0]); return c; };
const escapeXml = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');
const setCellText = (cellXml, newText) => {
  const paragraphs = []; const pRe = /<w:p\b[\s\S]*?<\/w:p>/g; let m;
  while ((m = pRe.exec(cellXml)) !== null) paragraphs.push(m[0]);
  if (!paragraphs.length) return cellXml;
  const firstPara = paragraphs[0];
  const runs = []; const rRe = /<w:r\b[\s\S]*?<\/w:r>/g;
  while ((m = rRe.exec(firstPara)) !== null) runs.push(m[0]);
  let newPara;
  if (!runs.length) {
    const at = firstPara.lastIndexOf('</w:p>');
    newPara = `${firstPara.substring(0, at)}<w:r><w:t xml:space="preserve">${escapeXml(newText)}</w:t></w:r></w:p>`;
  } else {
    const rPr = (runs[0].match(/<w:rPr>[\s\S]*?<\/w:rPr>/) || [''])[0];
    newPara = firstPara;
    runs.forEach((r) => { newPara = newPara.replace(r, ''); });
    const at = newPara.lastIndexOf('</w:p>');
    newPara = `${newPara.substring(0, at)}<w:r>${rPr}<w:t xml:space="preserve">${escapeXml(newText)}</w:t></w:r></w:p>`;
  }
  let newCell = cellXml;
  for (let i = paragraphs.length - 1; i >= 1; i--) newCell = newCell.replace(paragraphs[i], '');
  return newCell.replace(firstPara, newPara);
};

// Ligne d'article « à balises » (ex. {{designation}} {{quantite}} {{prix_unitaire}} {{montant}}) :
// on l'encadre par {{#lignes}} … {{/lignes}} (première / dernière cellule) pour que docxtemplater
// répète la ligne pour chaque article. Retourne { xml, injected }.
export const ITEM_ROW_TAGS = ['designation', 'prix_unitaire', 'montant', 'quantite', 'unite', 'num'];
export const injectRowLoop = (xml) => {
  const rows = getTableRows(xml);
  const target = rows.find((r) => { const t = getRowText(r.xml); return /\{\{\s*designation\s*\}\}/.test(t) && !/\{\{\s*[#/]lignes/.test(t); });
  if (!target) return { xml, injected: false };
  const cells = getRowCells(target.xml);
  if (cells.length < 1) return { xml, injected: false };
  const openTag = (cell) => {
    const m = cell.match(/<w:t(?:\s[^>]*)?>/);
    if (!m) return cell.replace(/(<w:p(?:\s[^>]*)?>(?:<w:pPr>[\s\S]*?<\/w:pPr>)?)/, `$1<w:r><w:t xml:space="preserve">{{#lignes}}</w:t></w:r>`);
    const at = m.index + m[0].length;
    return `${cell.slice(0, at)}{{#lignes}}${cell.slice(at)}`;
  };
  const closeTag = (cell) => {
    const at = cell.lastIndexOf('</w:t>');
    if (at < 0) return cell.replace(/<\/w:p>(?![\s\S]*<\/w:p>)/, `<w:r><w:t xml:space="preserve">{{/lignes}}</w:t></w:r></w:p>`);
    return `${cell.slice(0, at)}{{/lignes}}${cell.slice(at)}`;
  };
  let row = target.xml;
  const first = cells[0];
  if (cells.length === 1) {
    row = row.replace(first, closeTag(openTag(first)));
  } else {
    row = row.replace(first, openTag(first));
    const cells2 = getRowCells(row);
    row = row.replace(cells2[cells2.length - 1], closeTag(cells2[cells2.length - 1]));
  }
  return { xml: xml.replace(target.xml, row), injected: true };
};

export const modifyItemsTable = (xml, items) => {
  const info = findItemsTableInXml(xml);
  if (!info) throw new Error("Le modèle ne contient pas de tableau d'articles valide (tableau avec TOTAL/TVA introuvable)");
  const rows = getTableRows(info.table);
  let headerIdx = -1, firstIdx = -1, lastIdx = -1;
  for (let i = 0; i < rows.length; i++) {
    const text = getRowText(rows[i].xml);
    if ((text.includes('signation') || text.includes('Désignation')) && text.includes('N')) headerIdx = i;
    else if (headerIdx >= 0 && firstIdx < 0) { if (getRowCells(rows[i].xml).length >= 6) firstIdx = i; }
    else if (firstIdx >= 0 && lastIdx < 0) { if (getRowCells(rows[i].xml).length < 6 || text.includes('TOTAL')) lastIdx = i - 1; }
  }
  if (firstIdx < 0) return xml; // pas de ligne d'article : on laisse le tableau tel quel
  if (lastIdx < 0) lastIdx = firstIdx;
  const templateRow = rows[firstIdx].xml;
  const newRows = items.map((item, idx) => {
    const cells = getRowCells(templateRow);
    if (cells.length >= 6) {
      const vals = [String(idx + 1), item.designation || '', item.unite || 'F', String(item.quantite || 1), formatNumber2(item.prix_unitaire || 0), formatNumber2(item.montant || 0)];
      let row = templateRow;
      cells.forEach((c, i) => { if (i < 6) row = row.replace(c, setCellText(c, vals[i])); });
      return row;
    }
    return templateRow;
  });
  let newTable = info.table;
  for (let i = lastIdx; i >= firstIdx; i--) newTable = newTable.replace(rows[i].xml, '');
  const after = rows[lastIdx + 1];
  newTable = after ? newTable.replace(after.xml, newRows.join('') + after.xml) : newTable.replace('</w:tbl>', `${newRows.join('')}</w:tbl>`);
  return xml.substring(0, info.tableStart) + newTable + xml.substring(info.tableEnd);
};

export const addEspeceRows = (xml, fraisTimbreStr, totalFinalStr) => {
  const info = findItemsTableInXml(xml);
  if (!info) return xml;
  const rows = getTableRows(info.table);
  const ttcIdx = rows.findIndex((r) => /TOTAL\s+TTC/.test(getRowText(r.xml)));
  if (ttcIdx < 0) return xml;
  // Libellé dans la cellule qui contient « TOTAL » (première cellule sinon), valeur dans la dernière cellule
  const clone = (label, value) => {
    let row = rows[ttcIdx].xml;
    let cells = getRowCells(row);
    if (cells.length) {
      let labelIdx = cells.findIndex((c) => getRowText(c).includes('TOTAL'));
      if (labelIdx < 0 || labelIdx === cells.length - 1) labelIdx = 0;
      row = row.replace(cells[labelIdx], setCellText(cells[labelIdx], label));
      cells = getRowCells(row);
    }
    if (cells.length >= 2) row = row.replace(cells[cells.length - 1], setCellText(cells[cells.length - 1], value));
    return row;
  };
  const extra = clone('Frais du timbre', fraisTimbreStr) + clone('TOTAL', totalFinalStr);
  const after = rows[ttcIdx + 1];
  const newTable = after ? info.table.replace(after.xml, extra + after.xml) : info.table.replace('</w:tbl>', `${extra}</w:tbl>`);
  return xml.substring(0, info.tableStart) + newTable + xml.substring(info.tableEnd);
};

